<template>
  <a
    v-if="link"
    class="c-social-icon"
    :href="link"
    target="_blank"
    :aria-label="ariaLabelLink">
    <component
      v-if="iconName"
      class="c-social-icon__svg"
      :is="iconName" />
    <slot
      v-else
      name="iconSlot"></slot>
  </a>
</template>

<script>
import FacebookIcon from './assets/FacebookIcon.vue'
import IssuuIcon from './assets/IssuuIcon.vue'
import LinkedInIcon from './assets/LinkedInIcon.vue'
import TwitterIcon from './assets/TwitterIcon.vue'

export default {
  name: 'fh-social-icon',

  components: {
    'Facebook': FacebookIcon,
    'Issuu': IssuuIcon,
    'LinkedIn': LinkedInIcon,
    'Twitter': TwitterIcon
  },

  props: {
    link: {
      type: String,
      default: '',
      required: true
    },
    ariaLabelLink: {
      type: String,
      default: '',
      required: true
    },
    iconName: {
      type: String,
      validator: (value) => {
        return ['Facebook', 'Issuu', 'LinkedIn', 'Twitter'].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style lang="scss">
.c-social-icon {
  transition: opacity 0.25s ease-in-out;

  &:focus {
    outline: 2px dashed #fff;
  }
  &:hover {
    opacity: 0.85;
  }
}

.c-social-icon__svg {
  height: 40px;
  width: 40px;
  vertical-align: middle;
}
</style>
